import { Link } from "react-router-dom";
import { LOGO_URL, NAV_LINKS, CONTACT } from "@/lib/data";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 py-14">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Link to="/" className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-xl overflow-hidden ring-2 ring-[hsl(var(--accent))]/40">
                <img src={LOGO_URL} alt="LD Media" className="h-full w-full object-cover" />
              </div>
              <span className="font-display text-xl font-bold">
                LD <span className="text-[hsl(var(--accent))]">Media</span>
              </span>
            </Link>
            <p className="mt-5 text-white/55 max-w-sm text-sm leading-relaxed">
              Marketing-bureauet der ikke kun leverer rapporter. Vi leverer kunder. Annoncering, content,
              hjemmesider og branding under ét tag.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Navigation</div>
            <ul className="space-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-white/75 hover:text-[hsl(var(--accent))] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Kontakt</div>
            <ul className="space-y-3 text-sm text-white/75">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-[hsl(var(--accent))] transition-colors">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-[hsl(var(--accent))] transition-colors">
                  {CONTACT.phone}
                </a>
              </li>
            </ul>

            <div className="mt-6 flex gap-2">
              {["Instagram", "TikTok"].map((s) => (
                <a
                  key={s}
                  href="#"
                  className="text-xs px-3.5 py-1.5 rounded-full border border-white/15 hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))] transition-colors"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} LD Media · Alle rettigheder forbeholdes</div>
          <div>Bygget med fokus på vækst.</div>
        </div>
      </div>
    </footer>
  );
};
